/**
 * XLSX → CSV, ein Dokument pro Tabellenblatt (client.md §10).
 */
import * as XLSX from "xlsx";

export type CsvDocument = { doc_id: string; content: string };

export async function xlsxToCsvDocuments(file: File): Promise<CsvDocument[]> {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array" });
  const baseName = file.name.replace(/\.xlsx?$/i, "");
  const sheetNames = wb.SheetNames;
  return sheetNames.map((name) => {
    const csv = XLSX.utils.sheet_to_csv(wb.Sheets[name]);
    const doc_id = sheetNames.length === 1 ? `${baseName}.csv` : `${baseName}_${name}.csv`;
    return { doc_id, content: csv };
  });
}
